export type WsTrafficClass = 'reliable' | 'droppable' | 'high-volume';

const HIGH_VOLUME_TYPES = new Set(['minigame_input', 'minigame_snapshot']);
const DROPPABLE_SERVER_TYPES = new Set(['minigame_snapshot']);

export function normalizeWsMessageType(type: string | null | undefined): string | null {
  if (typeof type !== 'string') return null;
  const normalized = type
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');
  return normalized.length === 0 ? null : normalized;
}

export function isHighVolumeWsMessageType(type: string | null | undefined): boolean {
  const normalized = normalizeWsMessageType(type);
  return normalized != null && HIGH_VOLUME_TYPES.has(normalized);
}

export function isDroppableServerMessageType(type: string | null | undefined): boolean {
  const normalized = normalizeWsMessageType(type);
  return normalized != null && DROPPABLE_SERVER_TYPES.has(normalized);
}
